import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FileStatusButton, FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close } from "@air/next-icons";
import pluralize from "pluralize";
import { memo, useCallback, useEffect, useRef } from "react";
import { PaneItemTW } from "~/components/FileStatusTrackingPane/PaneItemTW";
import { DownloadFile, isS3DownloadUrlActive } from "~/utils/DownloadFile";
export const ZippingTaskCompletedPanelItem = /*#__PURE__*/ memo((param)=>{
    let { metadata: { url, clipIds = [], boardIds = [] }, onClear, onHandleExpiredLink } = param;
    const downloadedRef = useRef(false);
    /**
     * By being in ref, it prevents the `download` function from changing
     * and thus not triggering the download `useEffect` below.
     */ const handleExpiredLinkRef = useRef(onHandleExpiredLink);
    handleExpiredLinkRef.current = onHandleExpiredLink;
    const download = useCallback((url)=>{
        /**
       * This ref is to ensure the user doesn't start automically downloading the zip again.
       * After they start the download, we don't clear the downloaded item because it's possible
       * their download never started but we don't want to potentially automatically download again
       */ if (isS3DownloadUrlActive(url) && !downloadedRef.current) {
            DownloadFile(url);
            downloadedRef.current = true;
        } else {
            handleExpiredLinkRef.current();
        }
    }, []);
    useEffect(()=>{
        if (url) {
            download(url);
        }
    }, [
        download,
        url
    ]);
    return /*#__PURE__*/ _jsx(PaneItemTW, {
        avatar: /*#__PURE__*/ _jsx(FileStatusIconCompleted, {}),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            "data-testid": "ZIPPING_PANEL_COMPLETED_TITLE",
            children: "Zipped ".concat(pluralize("item", clipIds.length + boardIds.length, true))
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "Download didn't start? ",
                    /*#__PURE__*/ _jsx("button", {
                        className: "text-12 text-blue-9 hover:text-blue-11 hover:underline",
                        onClick: ()=>{
                            if (url) {
                                download(url);
                            }
                        },
                        children: "Click here"
                    })
                ]
            })
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusButton, {
            label: "Clear",
            onClick: ()=>onClear(),
            children: /*#__PURE__*/ _jsx(Close, {
                className: "size-4"
            })
        })
    });
});
ZippingTaskCompletedPanelItem.displayName = "ZippingCompletedPanelItem";
